import loadable from '@loadable/component';

export const ElectronicTradingWidgetLoadable = loadable(
  () => import('../../packages/electronic-trading-widget/components/ElectronicTradingWidget/ElectronicTradingWidget'),
  {
    ssr: false,
  },
);
